import { localeRegistry } from './resources';

export const LANGUAGE_STORAGE_KEY = 'bubble-wallet-language';
export type AppLanguage = keyof typeof localeRegistry;
export const supportedLanguages = Object.keys(localeRegistry) as AppLanguage[];
export const languageOptions: Array<{ value: AppLanguage; label: string }> = Object.entries(localeRegistry)
  .map(([value, locale]) => ({ value: value as AppLanguage, label: locale.label }));

export function isAppLanguage(value: string | null | undefined): value is AppLanguage {
  return Boolean(value && supportedLanguages.includes(value as AppLanguage));
}

export function readInitialLanguage(): AppLanguage {
  if (typeof window === 'undefined') return 'en';
  try {
    const stored = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
    return isAppLanguage(stored) ? stored : 'en';
  } catch {
    return 'en';
  }
}

export function updateDocumentLanguage(language: AppLanguage): void {
  if (typeof document === 'undefined') return;
  document.documentElement.lang = language;
}

export function persistLanguage(language: AppLanguage): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  } catch {
    // Continue with the current language when storage is unavailable.
  }
}
